import { FIND_LOG_SOURCE_THROTTLE_MS } from '../../config/findRemoteLogging';

const lastEmitAtByKey = new Map();

export function shouldThrottleSource(sourceKey, now = Date.now()) {
  const minMs = FIND_LOG_SOURCE_THROTTLE_MS[sourceKey] ?? FIND_LOG_SOURCE_THROTTLE_MS.default;
  const last = lastEmitAtByKey.get(sourceKey) ?? 0;
  if (now - last < minMs) {
    return true;
  }
  lastEmitAtByKey.set(sourceKey, now);
  return false;
}

export function resetSourceThrottle() {
  lastEmitAtByKey.clear();
}
